/**
 * Mock de imagenología — estudios de hoy por especialidad y por centro.
 * Reemplazar por hooks reales sin cambiar el layout del hub.
 */

export interface SpecialtyStudyCount {
  specialty: string;
  count: number;
}

export interface CenterStudyCount {
  center: string;
  count: number;
}

export const MOCK_IMAGING_STUDIES_TODAY = 186;

export const MOCK_STUDIES_BY_SPECIALTY: SpecialtyStudyCount[] = [
  { specialty: "Radiología", count: 62 },
  { specialty: "Tomografía", count: 41 },
  { specialty: "Resonancia", count: 28 },
  { specialty: "Ecografía", count: 35 },
  { specialty: "Mamografía", count: 20 },
];

export const MOCK_STUDIES_BY_CENTER: CenterStudyCount[] = [
  { center: "Centro Norte", count: 74 },
  { center: "Clínica Sur", count: 51 },
  { center: "Hospital Central", count: 39 },
  { center: "Unidad Móvil", count: 22 },
];
